var _style, _ellipse, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCE7A1;}\n\t.st1{fill:none;stroke:#020202;stroke-miterlimit:10;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 26.14,
    cy: 21.28,
    rx: 14.01,
    ry: 14.58
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,20.45l8.85,2.33c0,0,5.59-5.83,2.56-12.35c-0.58-0.87-2.16-5.01-7.63-1.63 C30.29,10.14,27.2,11.71,27.9,20.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.66,23.77L34.78,25c0,0,0.76,6.17-3.06,8.44c-0.84,0.29-4.11,1.86-5.16-3.09 C26.56,28.6,26.68,25.22,28.66,23.77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.9,28.84l-8.62,2.5c0,0-4.6-3.44-3.2-10.95c0.35-1.11,1.86-5.42,6.47-4.08 C17.07,16.54,23.3,19.34,21.9,28.84z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.2,33.67l6-1.51c0,0,3.5,2.74,1.57,8.45c-0.29,0.58-1.46,3.09-5.18,0.82C17.01,40.89,15.14,39.61,15.2,33.67 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalking);
export default __webpack_public_path__ + "static/media/Walking.b2cc9c21d0c898dc0d9fc66c7903c7f1.svg";
export { ForwardRef as ReactComponent };